import { format, parse } from "date-fns"

import { ukDateOf, ukDayEnd, ukDayStart, ukWallClockToInstant } from "@/constants/sheriffOptions"

/**
 * The shift edit dialog keeps its date as a `Date` so the calendar picker can use it.
 * That `Date` only carries a calendar day, held as local midnight, so the day shown is
 * the day read back whatever the browser's timezone. The time of day lives in the
 * separate HH:mm field.
 */

/** The UK calendar day of an instant, as a local-midnight `Date`. */
export const ukCalendarDate = (instant: Date): Date =>
  parse(ukDateOf(instant), "yyyy-MM-dd", new Date())

/** The calendar day a picker `Date` holds, as YYYY-MM-DD. */
const calendarDateString = (date: Date): string => format(date, "yyyy-MM-dd")

/** The instant named by a picker `Date` and an HH:mm UK time. Invalid Date if it doesn't exist. */
export const ukInstantOf = (date: Date, time: string): Date =>
  ukWallClockToInstant(calendarDateString(date), time)

/** The first instant of the UK day a picker `Date` holds. */
export const ukDayStartOf = (date: Date): Date => ukDayStart(calendarDateString(date))

/** The last millisecond of the UK day a picker `Date` holds. */
export const ukDayEndOf = (date: Date): Date => ukDayEnd(calendarDateString(date))
